import { Application } from '../../blocks/common/components/application';
import { AppBuilder } from '../../blocks/pages/app-builder/app-builder';
import { WhatYouSeeIsWhatYouGetEditor } from '../../blocks/pages/app-builder/what-you-see-is-what-you-get-editor';
import { WhySnappiiAppBuilder } from '../../blocks/pages/app-builder/why-snappii-app-builder';
import { ContactSnappiiToLearn } from '../../blocks/pages/app-builder/contact-snappii-to-learn';

class Main extends Application {
    async init() {
        await super.init();

        const appBuilder = new AppBuilder();
        const initAppBuilderOptions = {
            store: this.store
        };
        appBuilder.init(initAppBuilderOptions);

        const whatYouSeeIsWhatYouGetEditor = new WhatYouSeeIsWhatYouGetEditor();
        const initWhatYouSeeIsWhatYouGetEditorOptions = {
            store: this.store
        };
        whatYouSeeIsWhatYouGetEditor.init(initWhatYouSeeIsWhatYouGetEditorOptions);

        const whySnappiiAppBuilder = new WhySnappiiAppBuilder();
        const initWhySnappiiAppBuilderOptions = {
            store: this.store
        };
        whySnappiiAppBuilder.init(initWhySnappiiAppBuilderOptions);

        const contactSnappiiToLearn = new ContactSnappiiToLearn();
        const initWContactSnappiiToLearnOptions = {
            store: this.store
        };
        contactSnappiiToLearn.init(initWContactSnappiiToLearnOptions);

    }
}

const application = new Main();
application.init();
window['application'] = application;